import type { Observable } from 'rxjs';
import type { ELanguages } from '@common/enums';
import type { Uuid } from '@common/types';
import type { SiteCreateRequest, SiteEntity, UpdateSiteRequest } from '@common/types/site.type';
import type { FileEditType } from '@common/types/editor-file.type';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import SiteActions from './site.actions';
import * as SiteSelectors from './site.selectors';

@Injectable()
export class SiteFacade {
    private readonly store = inject(Store);

    public readonly id$: Observable<number | Uuid> = this.store.select(SiteSelectors.selectSiteId);
    public readonly name$: Observable<string> = this.store.select(SiteSelectors.selectSiteName);
    public readonly site$: Observable<SiteEntity> = this.store.select(SiteSelectors.selectSite);
    public readonly newSiteData$: Observable<Partial<SiteCreateRequest>> = this.store.select(
        SiteSelectors.selectNewSiteData
    );
    public readonly isSaving$: Observable<boolean> = this.store.select(SiteSelectors.selectSiteSaving);
    public readonly lang$: Observable<ELanguages> = this.store.select(SiteSelectors.selectLanguage);
    public readonly siteAvailablePageCount$: Observable<number> = this.store.select(
        SiteSelectors.selectSiteAvailablePageCount
    );
    public readonly isNewSite$: Observable<boolean> = this.store.select(SiteSelectors.selectSiteIsNew);
    public readonly isActiveSite$: Observable<boolean> = this.store.select(SiteSelectors.selectSiteIsActive);
    public readonly isSitePublished$: Observable<boolean> = this.store.select(SiteSelectors.selectSiteIsPublished);
    public readonly sitePublishedDate$: Observable<string> = this.store.select(SiteSelectors.selectSitePublishedDate);

    public setNewSiteData({ name, domain }): void {
        this.store.dispatch(SiteActions.setNewSiteData({ name, domain }));
    }

    public saveSiteRequest(
        exit: boolean,
        publish: boolean,
        pageId: string | number,
        navigateTo?: { pageId?: string; siteId?: string; isNew?: boolean }
    ): void {
        this.store.dispatch(SiteActions.saveSiteRequest({ exit, publish, navigateTo, capturedPageId: pageId }));
    }

    public updateSite(siteId: number, data: UpdateSiteRequest, updateDomains: boolean = false): void {
        this.store.dispatch(SiteActions.updateSiteRequest({ siteId, data, updateDomains }));
    }

    public uploadImage(data: FileEditType): void {
        this.store.dispatch(SiteActions.uploadImage({ data }));
    }

    public onlyUploadImage(data: any): void {
        console.log('onlyUploadImage', data);
        this.store.dispatch(SiteActions.onlyUploadImage({ data }));
    }

    public uploadImageSuccess(): void {
        this.store.dispatch(SiteActions.uploadImageSuccess());
    }

    public resizeImage({ path, url }: { path: string; url: string }): void {
        this.store.dispatch(SiteActions.resizeImage({ path, url }));
    }
}
